import { Box, styled } from '@mui/material';

const Container = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

const HeaderRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

const InfoRow = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
}));

const ContactSection = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

const CategoryBadge = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(0.5),
  padding: `${theme.spacing(0.5)} ${theme.spacing(1.5)}`,
  backgroundColor: '#cafff8',
  borderRadius: theme.spacing(1),
  fontSize: '0.875rem',
  display: 'inline-block',
}));

const SalesRepBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

const StyledLinkSpan = styled('span')(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '0.95rem',
  color: theme.palette.primary.main,
  cursor: 'pointer',
}));

export { Container, HeaderRow, InfoRow, ContactSection, CategoryBadge, SalesRepBox, StyledLinkSpan };
